import { autoinject } from 'aurelia-framework';
import { BaseApiService } from './base-api-service';
import { Models } from 'models/core';
import { AuthHttpClient } from './auth-http-client';

@autoinject
export class ServiceConsumptionMaterialWashingService extends BaseApiService<Models.ServiceConsumptionMaterialWashing> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, Models.ServiceConsumptionMaterialWashing);
  }
}
